import * as go from 'gojs';

export const setupToolLifecycleListeners = (
  tool: go.Tool,
  onToolActivated: () => void,
  onToolDeactivated: () => void,
) => {
  const doActivateBase = tool.doActivate.bind(tool);
  const doDeactivateBase = tool.doDeactivate.bind(tool);

  tool.doActivate = () => {
    doActivateBase();
    onToolActivated();
  };

  tool.doDeactivate = () => {
    onToolDeactivated();
    doDeactivateBase();
  };
};
